import { render } from "./ModalViewTemplateMail.vue?vue&type=template&id=08d10448&ts=true"
import script from "./ModalViewTemplateMail.vue?vue&type=script&lang=ts"
export * from "./ModalViewTemplateMail.vue?vue&type=script&lang=ts"

import "./ModalViewTemplateMail.vue?vue&type=style&index=0&id=08d10448&lang=css"

import exportComponent from "/home/devadm/tuyensinh-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__